import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import {
  ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip, CartesianGrid, Legend,
} from "recharts";

export default function MonthlyDashboard() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/dashboard/monthly").then((r) => setData(r.data)); }, []);

  return (
    <div className="space-y-6">
      <div>
        <p className="text-[10px] font-bold uppercase tracking-[0.25em] text-blue-700">Período 28 → 27</p>
        <h1 className="font-display text-3xl font-bold tracking-tight text-slate-900">Dashboard Mensal</h1>
        {data && (
          <p className="mt-1 text-sm text-slate-500">
            De {new Date(data.period_start + "T00:00:00").toLocaleDateString("pt-BR")} até {new Date(data.period_end + "T00:00:00").toLocaleDateString("pt-BR")}
          </p>
        )}
      </div>

      <div className="grid grid-cols-2 gap-4 lg:grid-cols-6">
        <Kpi label="Entregues" value={data?.total_entregues} accent="text-green-700" />
        <Kpi label="Retornos" value={data?.total_retornos} accent="text-amber-700" />
        <Kpi label="Fora Lista" value={data?.total_fora_lista} accent="text-red-700" />
        <Kpi label="Fechamentos" value={data?.total_fechamentos} accent="text-slate-700" />
        <Kpi label="Motoristas" value={data?.motoristas_unicos} accent="text-blue-700" />
        <Kpi label="Média diária" value={data?.media_diaria_entregues} accent="text-blue-700" />
      </div>

      <div className="rounded-xl border border-slate-200 bg-white p-5">
        <p className="text-[10px] font-bold uppercase tracking-[0.25em] text-blue-700">Evolução diária</p>
        <h2 className="mb-4 font-display text-lg font-semibold text-slate-900">Entregas vs Retornos vs Fora Lista</h2>
        <div className="h-[360px] w-full" data-testid="monthly-chart">
          {data?.chart && data.chart.length > 0 ? (
            <ResponsiveContainer width="100%" height="100%">
              <BarChart data={data.chart}>
                <CartesianGrid strokeDasharray="3 3" stroke="#E2E8F0" />
                <XAxis dataKey="date" tick={{ fontSize: 11, fill: "#64748B" }} />
                <YAxis tick={{ fontSize: 11, fill: "#64748B" }} />
                <Tooltip />
                <Legend wrapperStyle={{ fontSize: 12 }} />
                <Bar dataKey="entregues" name="Entregues" fill="#16A34A" radius={[6, 6, 0, 0]} />
                <Bar dataKey="retornos" name="Retornos" fill="#EAB308" radius={[6, 6, 0, 0]} />
                <Bar dataKey="fora" name="Fora Lista" fill="#DC2626" radius={[6, 6, 0, 0]} />
              </BarChart>
            </ResponsiveContainer>
          ) : (
            <p className="grid h-full place-items-center text-sm text-slate-400">Sem dados no período.</p>
          )}
        </div>
      </div>
    </div>
  );
}

function Kpi({ label, value, accent }) {
  return (
    <div className="rounded-xl border border-slate-200 bg-white p-4">
      <p className="text-[10px] font-bold uppercase tracking-[0.2em] text-slate-500">{label}</p>
      <p className={`mt-1 font-display text-2xl font-bold ${accent}`}>{value ?? "—"}</p>
    </div>
  );
}
